document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.my-account-edit')) return;

  const changeEmailForm =
    document.querySelector<HTMLFormElement>('#change-email')!;
  const changeEmailInput = document.querySelector<HTMLInputElement>(
    '#change-email-email',
  )!;
  const changeEmailSubmit = document.querySelector<HTMLButtonElement>(
    '#change-email-submit',
  )!;
  const changeEmailSuccess = document.querySelector<HTMLElement>(
    '#change-email-success',
  )!;
  const changeEmailDanger = document.querySelector<HTMLElement>(
    '#change-email-danger',
  )!;
  const searchAddByZipCdLink = document.querySelector<HTMLAnchorElement>(
    '#search-add-by-zip-cd',
  )!;
  const receiveOtherPostingNotice1 = document.querySelector<HTMLElement>(
    '#receive-other-posting-notice1',
  )!;
  const receiveOtherPostingNotice2 = document.querySelector<HTMLElement>(
    '#receive-other-posting-notice2',
  )!;
  const receiveStudyPosting = document.querySelectorAll<HTMLInputElement>(
    'input[name="account_update[receive_study_posting]"]',
  )!;
  const zipCodeInput = document.querySelector<HTMLInputElement>(
    'input[name="account_update[account_address_attributes][zip_code]"]',
  )!;
  const errorField = document.querySelector<HTMLElement>('#error_explanation')!;

  const changeEmailHandler = async (event: Event) => {
    event.preventDefault();

    if (!changeEmailInput.checkValidity()) {
      $('<input type="submit">')
        .hide()
        .appendTo(changeEmailForm)
        .trigger('click')
        .remove();
      return;
    }

    changeEmailSuccess.classList.add('hidden');
    changeEmailDanger.classList.add('hidden');

    $.ajax(changeEmailForm.action, {
      dataType: 'json',
      method: changeEmailForm.method,
      data: {
        email: changeEmailInput.value,
      },
    })
      .done((data) => {
        changeEmailSuccess.textContent = data.message;
        changeEmailInput.value = data.email;
        changeEmailSuccess.classList.remove('hidden');
      })
      .fail((xhr, _, errorThrown) => {
        changeEmailDanger.textContent =
          xhr?.responseJSON?.message || `不明なエラーです: ${errorThrown}`;
        const email = xhr?.responseJSON?.email;
        if (email) {
          changeEmailInput.value = email;
        }
        changeEmailDanger.classList.remove('hidden');
      });
  };

  const changeZipcodeHandler = (v: string) => {
    if (v.length === 7) {
      searchAddByZipCdLink.classList.remove('disabled');
    } else {
      searchAddByZipCdLink.classList.add('disabled');
    }
  };

  const toggleReceiveStudyPosting = () => {
    const $addressInputs = $('#address-related-field').find(':input');

    if (
      Array.from(receiveStudyPosting).some(
        (input) => input.checked && input.value === 'true',
      )
    ) {
      $addressInputs.prop('disabled', false);
      searchAddByZipCdLink.onclick = searchAddress;
      receiveOtherPostingNotice1.classList.remove('is-disabled-color');
      receiveOtherPostingNotice2.classList.remove('is-disabled-color');
      changeZipcodeHandler(zipCodeInput.value);
    } else {
      resetErrorField();
      $addressInputs.prop('disabled', true);
      searchAddByZipCdLink.removeEventListener('click', searchAddress);
      searchAddByZipCdLink.onclick = (event) => event.preventDefault();
      searchAddByZipCdLink.classList.add('disabled');
      receiveOtherPostingNotice1.classList.add('is-disabled-color');
      receiveOtherPostingNotice2.classList.add('is-disabled-color');
    }
  };

  const resetErrorField = () => {
    const validationItems = errorField.querySelectorAll('li.front-validation');
    validationItems.forEach((item) => item.remove());

    if (errorField.querySelector('li') === null) {
      errorField.classList.add('hidden');
    }
  };

  const searchAddress = async (event: Event) => {
    event.preventDefault();

    const val = zipCodeInput.value;

    if (!val) return;

    $.ajax(`/api/addresses?zip_code=${val}`, {
      dataType: 'json',
      method: 'GET',
    })
      .done((data) => {
        resetErrorField();
        $(
          `#account_update_account_address_attributes_prefecture option[value='${data.prefecture_code}']`,
        ).prop('selected', true);
        $('#account_update_account_address_attributes_prefecture').trigger(
          'change',
        );
        $('#account_update_account_address_attributes_city').val(data.city);
        $('#account_update_account_address_attributes_district').val(
          data.district,
        );
      })
      .fail((xhr) => {
        resetErrorField();
        errorField.classList.remove('hidden');

        const ul = errorField?.querySelector('ul');

        if (ul) {
          const message =
            xhr?.status === 404 ? xhr.responseJSON.message : '不明なエラーです';
          ul.innerHTML += `<li class='front-validation'>${message}</li>`;
        }
      });
  };

  changeEmailSubmit.addEventListener('click', changeEmailHandler);
  changeEmailForm.addEventListener('submit', changeEmailHandler);
  zipCodeInput.addEventListener('keyup', (e) =>
    changeZipcodeHandler((e.target as HTMLInputElement).value),
  );
  searchAddByZipCdLink.addEventListener('click', searchAddress);
  receiveStudyPosting.forEach((input) =>
    input.addEventListener('change', toggleReceiveStudyPosting),
  );

  if (zipCodeInput) changeZipcodeHandler(zipCodeInput.value);

  toggleReceiveStudyPosting();
});
